var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useState } from 'react';
import { getUniqueKey } from '../utils';
import { GroupButtonWrapper, GroupButtonStyled } from './styled';
const GroupButtonComponent = (_a) => {
    var props = __rest(_a, []);
    const { onClick, label, active: activeProps, orientation } = props, rest = __rest(props, ["onClick", "label", "active", "orientation"]);
    const [active, setActive] = useState(activeProps || false);
    const handleClick = (e) => {
        if (onClick)
            onClick(e);
        setActive(!active);
    };
    return (_createElement(GroupButtonStyled, Object.assign({}, rest, { orientation: orientation || 'horizontal', active: active, key: getUniqueKey(), onClick: handleClick }), label));
};
const GroupButton = (_a) => {
    var props = __rest(_a, []);
    const { data, padding, gap, orientation } = props, rest = __rest(props, ["data", "padding", "gap", "orientation"]);
    if (!data || data.length === 0)
        return null;
    return (_jsx(GroupButtonWrapper, Object.assign({ gap: gap, orientation: orientation }, { children: data.map((item) => (_jsx(GroupButtonComponent, Object.assign({ gap: gap, orientation: orientation, padding: padding }, item, rest), getUniqueKey()))) })));
};
GroupButton.defaultProps = {
    gap: '0px',
    orientation: 'horizontal',
    padding: '0px',
};
export default GroupButton;
//# sourceMappingURL=index.js.map